export default "__VITE_ASSET__CuMd4OnK__";